<template>
	<div class="container">
		<indexPc v-if="!isTrue"></indexPc>
		<indexH5 v-if="isTrue"></indexH5>
	</div>
</template>

<script>
import indexPc from '@/component/job/index_pc.vue'  //pc组件
import indexH5 from '@/component/job/index_h5.vue'  //h5组件
export default {
	components:{
		indexPc,
		indexH5,
	},
	metaInfo: {
		meta: [
			{
				name: "description",
				content: "",
			},{
				name: "keywords",
				content: "",
			}
		]
	},
	data() {
		return {
			isTrue: null,
		}
	},
	created(){
		let that = this;
		let isTrue = null;
		let isiPad = (navigator.userAgent.match(/(iPad)/) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
		if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|OpenHarmony|HarmonyOS|HarmonyOSNext|OpenHarmony/i.test(navigator.userAgent) || isiPad) {
			that.isTrue = true;
		}else {
			that.isTrue = false;
		}
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//
	}
}
</script>

<style lang="less" scoped>
</style>
